import {Grid} from '@primer/react-brand'

import {ContentfulSectionIntro} from '@github-ui/swp-core/components/contentful/ContentfulSectionIntro'
import {ContentfulRiverAccordion} from '@github-ui/swp-core/components/contentful/ContentfulRiverAccordion'
import type {PrimerComponentRiverAccordion} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentRiverAccordion'

import type {GenericSectionWithIds} from '../../../../brand/lib/types/contentful'

type Props = {
  contentfulContent: GenericSectionWithIds
}

export function RiverAccordionSection(props: Props) {
  const {contentfulContent} = props
  const {sectionIntro, content} = contentfulContent.fields

  const riverAccordionComponent = content?.find(
    item => item.sys.contentType.sys.id === 'primerComponentRiverAccordion',
  ) as PrimerComponentRiverAccordion | undefined

  if (!riverAccordionComponent) {
    return null
  }

  return (
    <Grid as="section" className="lp-Section pr-pt-5 pr-pt-lg-8 pr-pb-8">
      <Grid.Column span={12}>
        {sectionIntro ? (
          <ContentfulSectionIntro component={sectionIntro} fullWidth headingSize="3" className="pr-mb-6" />
        ) : null}

        <ContentfulRiverAccordion component={riverAccordionComponent} />
      </Grid.Column>
    </Grid>
  )
}
